import type { PartnerLpuSetData } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'
import {
  getLpuLogoImageFiles,
  type LpuLogoImageFile,
} from 'src/utils/getLpuAvatarUrl'

export type LpuSetCardProps = {
  name: string
  logoUrl: string
  logoFiles?: LpuLogoImageFile[]
  href: string
  reviewsHref: string
  branchesHref: string
  orderHref: string
  rating: number
  reviewsCount: number
  analysesCount: number
  laboratoriesCount: number
  townNamePred: string
  discount: number | null
  allLpusHasLicense: boolean
}

type MapLpuSetCardOptions = {
  townNamePred: string
  getLpuSetHref: (_translit: string) => string
  lpuSetOrderHref: string
}

type MapLpuSetCardItem = {
  name?: string
  translit?: string
  stars?: number | null
  rates?: number | null
  analyses_count?: number
  laboratories_count?: number | null
  discount?: number | null
  logo_image?: {
    url?: string | null
  } | null
  logo?: {
    priority_image_files?: LpuLogoImageFile[]
  }
  partner_lpuset_data?: PartnerLpuSetData | null
}

const mapLpuSetCard = (
  item: MapLpuSetCardItem,
  {
    townNamePred,
    getLpuSetHref,
    lpuSetOrderHref,
  }: MapLpuSetCardOptions,
): LpuSetCardProps => {
  const partner = item.partner_lpuset_data
  const href = getLpuSetHref(partner?.translit || item.translit || '')

  return {
    name: partner?.name || item.name || '',
    logoUrl: item.logo_image?.url || '',
    logoFiles: getLpuLogoImageFiles(item),
    href,
    reviewsHref: `${href}#otzivi`,
    branchesHref: href,
    orderHref: lpuSetOrderHref,
    rating: partner?.stars ?? item.stars ?? 0,
    reviewsCount: partner?.rates_count ?? item.rates ?? 0,
    analysesCount: item.analyses_count ?? 0,
    laboratoriesCount: item.laboratories_count ?? 0,
    townNamePred,
    discount: item.discount || null,
    allLpusHasLicense: Boolean(partner?.all_lpus_has_license),
  }
}

export default mapLpuSetCard
